export default __webpack_public_path__ + "static/media/api.446616f4.png";